import { IconLock } from "@tabler/icons-react";
import { Fragment, useCallback } from "react";
import AuthorizationModal from "src/generator/_Modals/AuthorizationModal/AuthorizationModal";
import { useSaveEntry } from "src/generator/hooks/useSaveEntry";
import { PendingFilesProvider } from "src/generator/LogBar/PendingFilesContext";
import { crumb } from "src/utils";
import { Notification } from "src/utils/Notification";

import RowActionButton from "../RowActionButton/RowActionButton";

const InlineSaveButton = () => {
  const { saveEntry, loading, opened, open, close, usersSelect, disabled } =
    useSaveEntry();

  const handleOpen = useCallback(async () => {
    // Log inline save button click
    crumb("Inline Save Button: Clicked", {
      component: "InlineSaveButton",
      disabled,
    });

    try {
      await open();
    } catch (error) {
      crumb("Inline Save Button: Open modal failed", {
        error: String(error),
      });
      Notification("Error", String(error), "red");
    }
  }, [open, disabled]);

  return (
    <Fragment>
      <RowActionButton
        icon={<IconLock />}
        onClick={handleOpen}
        color="red"
        disabled={disabled}>
        Save
      </RowActionButton>
      <AuthorizationModal
        opened={opened}
        close={close}
        onSubmit={saveEntry}
        loading={loading}
        users={usersSelect}
        isEntry={true}
      />
    </Fragment>
  );
};

const InlineSaveButtonProvider = () => {
  return (
    <PendingFilesProvider>
      <InlineSaveButton />
    </PendingFilesProvider>
  );
};

export default InlineSaveButtonProvider;
